import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
} from '@chakra-ui/react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onResponder: () => void;
}

export const ProtocolsModal = ({ isOpen, onClose, onResponder }: Props) => {
  const data = [
    {
      nome: 'Protocolo de Hipertensão',
      data: '20/02/2026',
      prof: 'Dr. Carlos Mendes',
    },
    {
      nome: 'PHQ-9 - Questionário de Saúde do Paciente',
      data: '25/02/2026',
      prof: 'Dra. Ana Paula Santos',
    },
    {
      nome: 'RED/TIC - Avaliação de Tecnorestresse',
      data: '23/02/2026',
      prof: 'Dr. Fernando Silva',
    },
    {
      nome: 'COPSOQ-III - Fatores Psicossociais no Trabalho',
      data: '27/02/2026',
      prof: 'Dra. Beatriz Carvalho',
    },
    {
      nome: 'Protocolo de Diabetes Tipo 2',
      data: '18/02/2026',
      prof: 'Dr. Roberto Lima',
    },
    {
      nome: 'Protocolo de Saúde Mental',
      data: '28/02/2026',
      prof: 'Dra. Mariana Costa',
    },
    {
      nome: 'Protocolo de Nutrição',
      data: '22/02/2026',
      prof: 'Dra. Juliana Ferreira',
    },
  ];

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="5xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Lista de Protocolos</ModalHeader>
        <ModalCloseButton />

        <ModalBody pb={6}>
          <Table>
            <Thead>
              <Tr>
                <Th>Nome</Th>
                <Th>Data</Th>
                <Th>Profissional</Th>
                <Th>Ação</Th>
              </Tr>
            </Thead>

            <Tbody>
              {data.map((item, i) => (
                <Tr>
                  <Td>{item.nome}</Td>
                  <Td>{item.data}</Td>
                  <Td>{item.prof}</Td>
                  <Td>
                    <Button
                      size="sm"
                      color="white"
                      bg="#60C2B0"
                      onClick={onResponder}
                    >
                      Responder
                    </Button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
